// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  if (chunkId === "7888") return "css/design_system-91f3c4bf500bfa47.css";
if (chunkId === "5416") return "css/5416-407b17dbc4247f26.css";
if (chunkId === "6496") return "css/6496-0573bf035ed5dce9.css";
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"2080": "25e43d52410aceac","2429": "c5b074131e392dae","2515": "a20454e2e90d9cc1","4167": "25e43d52410aceac","6283": "9cdd851a0a044552","7409": "25e43d52410aceac","8858": "a8d311b114ec77ce",}[chunkId] + ".css"
}